import type {Maybe, Nullable} from "../../bootstrap/common/types";

export function isDefined<T>(value: Maybe<T>): value is T {
    return value !== undefined;
}

export function isNotNull<T>(value: Nullable<T>): value is T {
    return value !== null;
}

export function isPresent<T>(value: Nullable<Maybe<T>>): value is T {
    return value !== undefined && value !== null;
}

export function isUndefined(value: any): value is undefined {
    return value === undefined;
}

export function isNull(value: any): value is null {
    return value === null;
}

export function falsyToUndefined<T>(value: Nullable<Maybe<T>>): Maybe<T> {
    if (!value) {
        return undefined;
    }
    return value;
}

export function reduceToNullable<T>(value: Maybe<T>): Nullable<T> {
    return value ?? null;
}

export function reduceToMaybe<T>(value: Nullable<T>): Maybe<T> {
    return value ?? undefined;
}